import React, { useState } from "react";
import { motion } from "framer-motion";
import "../../../programs.css";
import bgImage from "../../../Image/robotics.png";
import RFAQ from "./RFAQ";
import RCurriculum from "./RCurriculum";
import Certificate from "../../Certificate";
import SkillPage from "../../SkillPage";
import RPricing from "./RPricing";
import { Link } from "react-router-dom";
export default function Robotics() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    college: "",
    program: "Robotics",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxpGr46MBF4HmNpxOYLbt2mQRcjEVPS5PtI1iZdXAMgIxORthvV4iD0Ev1zPEAsXZoK/exec";

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (data.status === "success" || res.ok) {
        alert("Application submitted successfully!");
        setForm({
          fullName: "",
          email: "",
          phone: "",
          college: "",
          program: "Robotics",
        });
      } else {
        if (res.ok) {
          alert("Application submitted successfully!");
          setForm({
            fullName: "",
            email: "",
            phone: "",
            college: "",
            program: "Robotics",
          });
        } else {
          console.error("Submit error:", data);
          alert("There was an error submitting the form. Try again later.");
        }
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Network error — please check your connection and try again.");
    }
  };

  return (
    <>
      <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="program-detail-main">
          <h1 className="program-detail-title">Robotics</h1>
          <p className="program-detail-desc">
            Robotics turns code, sensors, and mechanics into intelligent
            movement. It creates machines that weld cars, assist surgeons,
            explore space, and automate factories. It transforms imagination
            into motion—teaching systems to observe, react, and solve problems
            in the physical world.
          </p>
          <div className="program-detail-actions">
            <Link to="/register">
              <button className="register-btn">Register Now</button>
            </Link>
            <Link to="/contact-us">
              <button className="expert-btn">Talk To Expert</button>
            </Link>
          </div>
        </div>
      </div>

      {/* -------------------- NEW SECTION START -------------------- */}

      <div className="program-container">
        <motion.div
          className="program-left1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="program-heading1">Program Overview</h2>
          <p className="program-description1">
            Robotics isn’t about assembling parts—it’s about designing machines
            that think through motion. At Acadme, you learn how motors, sensors,
            controllers, and algorithms work together in real time. You’ll build
            robots that follow paths, detect obstacles, grip objects, and
            respond to their environment. Training is deeply practical:
            mechanical design, wiring, actuation, PID tuning, and real-world
            debugging. The internship places you beside engineers solving
            automation challenges, testing prototypes, and learning why hardware
            behaves differently than theory. You gain instincts, discipline, and
            industry exposure that textbooks cannot teach.You are just one click
            away from the success—enroll and unlock endless opportunities with
            Acadme.
          </p>
        </motion.div>
        <motion.form
          className="program-form"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          onSubmit={handleSubmit}
        >
          <h3 className="form-title">Apply Now</h3>

          <div className="input-group">
            <label>
              <i className="fas fa-user"></i> Full Name
            </label>
            <input
              type="text"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-envelope"></i> Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-phone"></i> Phone Number
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+91 xxxxxxxxxx"
              maxLength="10"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-university"></i> College Name
            </label>
            <input
              type="text"
              name="college"
              value={form.college}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-code"></i> Program
            </label>
            <input type="text" name="program" value={form.program} readOnly />
          </div>

          <button className="submit-btn" type="submit">
            Submit
          </button>
        </motion.form>
      </div>

      {/* -------------------- NEW SECTION END -------------------- */}

      <RCurriculum />
      <SkillPage />
      <Certificate />
      <RPricing />
      <RFAQ />
    </>
  );
}
